{
  "name": "e2b",
  "version": "1.13.2",
  "description": "E2B SDK that give agents cloud environments",
  "homepage": "https://e2b.dev",
  "license": "MIT",
  "author": {
    "name": "FoundryLabs, Inc.",
    "email": "hello@e2b.dev",
    "url": "https://e2b.dev"
  },
  "bugs": "https://github.com/e2b-dev/e2b/issues",
  "repository": {
    "type": "git",
    "url": "https://github.com/e2b-dev/e2b",
    "directory": "packages/js-sdk"
  },
  "publishConfig": {
    "access": "public"
  },
  "sideEffects": false,
  "main": "dist/index.js",
  "module": "dist/index.mjs",
  "types": "dist/index.d.ts",
  "scripts": {
    "prepublishOnly": "pnpm build",
    "build": "tsc --noEmit && tsup",
    "dev": "tsup --watch",
    "example": "tsx example.mts",
    "test": "vitest run",
    "generate": "npm-run-all generate:*",
    "generate:api": "python ./../../spec/remove_extra_tags.py sandboxes templates auth && openapi-typescript ../../spec/openapi_generated.yml -x api_key --array-length --alphabetize --output src/api/schema.gen.ts",
    "generate:envd": "cd ../../spec/envd && buf generate --template buf-js.gen.yaml\n",
    "generate:envd-api": "openapi-typescript ../../spec/envd/envd.yaml -x api_key --array-length --alphabetize --output src/envd/schema.gen.ts",
    "generate-ref": "./scripts/generate_sdk_ref.sh",
    "check-deps": "knip",
    "update-deps": "ncu -u && pnpm i",
    "postPublish": "./scripts/post-publish.sh || true",
    "test:bun": "bun test tests/runtimes/bun --env-file=.env",
    "test:deno": "deno test tests/runtimes/deno/ --allow-net --allow-read --allow-env --unstable-sloppy-imports --trace-leaks",
    "test:integration": "E2B_INTEGRATION_TEST=1 vitest run tests/integration/**",
    "lint": "eslint src/ tests/"
  },
  "devDependencies": {
    "@testing-library/react": "^16.2.0",
    "@types/node": "^18.18.6",
    "@types/platform": "^1.3.6",
    "@types/react": "^18.3.11",
    "@typescript-eslint/eslint-plugin": "^7.11.0",
    "@typescript-eslint/parser": "^7.11.0",
    "@vitejs/plugin-react": "^4.3.4",
    "@vitest/browser": "^3.1.1",
    "dotenv": "^16.4.5",
    "eslint": "^8.57.1",
    "knip": "^5.43.6",
    "npm-check-updates": "^16.14.20",
    "npm-run-all": "^4.1.5",
    "openapi-typescript": "^7.6.1",
    "playwright": "^1.48.0",
    "react": "^18.3.1",
    "tsup": "^8.4.0",
    "typedoc": "0.26.8",
    "typedoc-plugin-markdown": "4.2.7",
    "typescript": "^5.4.5",
    "vitest": "^3.1.1",
    "vitest-browser-react": "^0.1.1"
  },
  "files": [
    "dist",
    "README.md",
    "package.json"
  ],
  "keywords": [
    "e2b",
    "ai-agents",
    "agents",
    "ai",
    "code-interpreter",
    "sandbox",
    "code",
    "runtime",
    "vm",
    "nodejs",
    "javascript",
    "typescript"
  ],
  "dependencies": {
    "@bufbuild/protobuf": "^2.6.2",
    "@connectrpc/connect": "2.0.0-rc.3",
    "@connectrpc/connect-web": "2.0.0-rc.3",
    "compare-versions": "^6.1.0",
    "openapi-fetch": "^0.9.7",
    "platform": "^1.3.6"
  },
  "engines": {
    "node": ">=18"
  },
  "browserslist": [
    "defaults"
  ]
}
